import i18n from '@/plugins/i18n';

export const getDataUsageNavTabs = () => [
  {
    name: i18n.global.t('agent-usage-dashboard'),
    path: 'usageDashboard',
  },
  {
    name: i18n.global.t('usage.license-usage'),
    path: 'licenseUsage',
    fullPath: 'usages/licenseUsage',
    overviewTab: [
      {
        tabName: i18n.global.t('mq.overview'),
        routerName: 'licenseOverview',
      },
      {
        tabName: i18n.global.t('usage.dataset-level'),
        routerName: 'licenseDatasetLevel',
      },
      {
        tabName: i18n.global.t('usage.session-level'),
        routerName: 'licenseSessionLevel',
        disabled: true,
      },
      {
        tabName: i18n.global.t('usage.endpoint-level'),
        routerName: 'licenseEndpointLevel',
        disabled: true,
      },
    ],
  },
];

const datausage = {
  key: 'usages',
  name: i18n.global.t('usage-dashboard'),
  icon: 'billingUsage',
  navTabs: getDataUsageNavTabs(),
};
export default datausage;
